export const RECEIVE_USERS = 'RECEIVE_USERS';
export const REQUEST_USERS = 'REQUEST_USERS';
export const RESET_USERS = 'RESET_USERS';
export const CHANGE_INPUT_USER = 'CHANGE_INPUT_USER';
